export default __webpack_public_path__ + "static/media/3.8e984c96.jpg";